import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';

export const updateCatalogOptOut: QueryFunction<Record<PropertyKey, never>> = async ({
  queryKey: [brand, enable],
}) => {
  return await api
    .put(`/reseller/catalog/${brand}/${enable ? 'enable' : 'disable'}`)
    .then((resp) => resp.data);
};
